import { CurrencyPipe } from '@angular/common';
import { Injectable, inject } from '@angular/core';
import { TranslationService } from './translation.service';

@Injectable({
  providedIn: 'root',
})
export class CurrencyService {
  private currencyPipe = inject(CurrencyPipe);

  private _userLanguage = 'en';

  setLanguage(lang: string): void {
    this._userLanguage = lang;
  }

  getCurrencyFormat(language?: string): string {
    const lang = this.getLanguage(language);
    switch (lang) {
      default:
        return '1.0-2';
    }
  }

  getCurrencyDisplay(currency?: string): string {
    // code, symbol-narrow, symbol or custom string
    switch (currency?.toUpperCase()) {
      case 'XAF':
      case 'SLE':
        return 'code';
      case 'SLL':
        return 'Se';
      case 'LRD':
        return 'LD$';
      case 'AUD':
      case 'NZD':
        return 'symbol';
      default:
        return 'symbol-narrow';
    }
  }

  getLanguage(lang?: string): string {
    if (!lang) return 'en';
    return TranslationService.supportedLanguages.includes(lang) ? lang : 'en';
  }

  getValueWithCurrency(value: number, currency: string): string {
    return (
      this.currencyPipe.transform(
        value,
        currency,
        this.getCurrencyDisplay(currency),
        this.getCurrencyFormat(this._userLanguage),
        this.getLanguage(this._userLanguage),
      ) || ''
    );
  }
}
